/**
 * Icon mapping for command palette commands
 * Maps command descriptions to their corresponding icon components
 */

// Import all SVG icons as React components
import HomeIcon from '../components/icons/home.svg?react';
import SettingsIcon from '../components/icons/settingsgearfill.svg?react';
import ChartIcon from '../components/icons/chartbarpeak.svg?react';
import ArrowDownIcon from '../components/icons/arrowdown.svg?react';
import ArrowUpIcon from '../components/icons/arrowup.svg?react';
import ChevronDoubleUpIcon from '../components/icons/chevrondoubleup.svg?react';
import ChevronDoubleDownIcon from '../components/icons/chevrondoubledown.svg?react';
import ChevronDownIcon from '../components/icons/chevrondown.svg?react';
import ChevronUpIcon from '../components/icons/chevronup.svg?react';
import CopyIcon from '../components/icons/copy.svg?react';
import MarkdownIcon from '../components/icons/acronymmarkdown.svg?react';
import CommandIcon from '../components/icons/command.svg?react';
import SidebarIcon from '../components/icons/sidebarleft.svg?react';
import CrossIcon from '../components/icons/cross.svg?react';
import CpuIcon from '../components/icons/cpu.svg?react';
import LightningIcon from '../components/icons/lightning.svg?react';
import PaperclipIcon from '../components/icons/paperclip.svg?react';
import StarIcon from '../components/icons/star.svg?react';
import TrashIcon from '../components/icons/trash.svg?react';
import MessageIcon from '../components/icons/message.svg?react';
import TargetIcon from '../components/icons/target.svg?react';

/**
 * Map of command descriptions to icon components
 */
export const COMMAND_ICONS = {
  'Go to chat (current conversation)': HomeIcon,
  'Go to settings page': SettingsIcon,
  'Go to usage page': ChartIcon,
  'Navigate to next message': ArrowDownIcon,
  'Navigate to previous message': ArrowUpIcon,
  'Go to first message': ChevronDoubleUpIcon,
  'Go to last message and scroll to bottom': ChevronDoubleDownIcon,
  'Scroll down': ChevronDownIcon,
  'Scroll up': ChevronUpIcon,
  'Copy focused message as plain text': CopyIcon,
  'Copy focused message as raw markdown': MarkdownIcon,
  'Open command menu': CommandIcon,
  'Toggle menu/sidebar': SidebarIcon,
  'Open search/command palette': CommandIcon,
  'Clear message focus': CrossIcon,
  'Set model (open model selector)': CpuIcon,
  'Set reasoning level (open thinking mode selector)': LightningIcon,
  'Set attachment (open file picker)': PaperclipIcon,
  'Toggle favorite for current conversation': StarIcon,
  'Delete current conversation': TrashIcon,
  'Create new chat': MessageIcon,
  'Focus chat input': TargetIcon,
};

/**
 * Get icon component for a command description
 * @param {string} description - Command description
 * @returns {React.Component|null} - Icon component or null if not found
 */
export const getCommandIcon = (description) => {
  return COMMAND_ICONS[description] || null;
};
